module.exports = __webpack_public_path__ + "static/media/menphysique.fc8dc4a6.jpg";